<h3 mat-dialog-title>
    Review proposed change
    <button mat-icon-button [disableRipple]="true" mat-dialog-close type="button" aria-label="Close">
        <i class="ph-bold ph-x close-icon icon-muted" aria-hidden="true"></i>
    </button>
</h3>

<mat-dialog-content>
    <div class="meta-row">
        <span class="meta-label">Operation</span>
        <span class="meta-value op-{{ data.proposal.operation }}">
            {{ data.proposal.operation | uppercase }} on {{ data.proposal.modelClass }}
        </span>
    </div>

    <div class="meta-row" *ngIf="data.proposal.entityId !== null">
        <span class="meta-label">Entity ID</span>
        <span class="meta-value">{{ data.proposal.entityId }}</span>
    </div>

    <div class="summary-block">
        {{ data.proposal.summary }}
    </div>

    <div class="payload-block" *ngIf="data.proposal.operation !== 'delete'">
        <div class="payload-label">Payload</div>
        <pre class="payload-json">{{ payloadJson }}</pre>
    </div>

    <div class="warning-row">
        <i class="ph-bold ph-warning-circle warning-icon icon-warning" aria-hidden="true"></i>
        <span>Approving will commit this write to the database. Idempotent on retry.</span>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button
        mat-flat-button
        type="button"
        color="accent"
        [disableRipple]="true"
        (click)="onCancel()">
        Cancel
    </button>

    <flex-spacer></flex-spacer>

    <button
        mat-stroked-button
        type="button"
        color="accent"
        class="destructive"
        [disableRipple]="true"
        (click)="onReject()">
        Reject
    </button>
    <button
        mat-flat-button
        type="button"
        color="primary"
        [disableRipple]="true"
        (click)="onApprove()">
        Approve
    </button>
</mat-dialog-actions>
